<template>
  <a-form :form="form" id="form">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-form-item label="Document Description">
          <a-input
            v-model="fungsi"
            v-decorator="[
              'fungsi',
              {
                rules: [
                  {
                    required: false,
                    message: 'Please input document description!',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Select Document">
          <a-upload
            accept=".pdf"
            :showUploadList="false"
            :beforeUpload="beforeUpload"
            v-decorator="['upload', { valuePropName: 'push' }]"
          >
            <a-button icon="upload"> Select File </a-button>
          </a-upload>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-card
          :loading="uploading"
          class="margin-top margin-bottom"
          title="Supporting documents"
        >
          <!-- <a-list
            itemLayout="horizontal"
            :loading="uploading"
            :dataSource="existing"
            v-if="mode === 'Edit' && existing.length > 0"
          >
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <div
                  slot="title"
                  class="m-display-flex space-between align-middle"
                >
                  <h3>{{ item.document_description }}</h3>
                  <a-button
                    @click="handleRemoveExisting(item.id_salesnotif_doc)"
                    type="link"
                    >Delete</a-button
                  >
                </div>
                <template slot="description">
                  <span :class="getScreen ? 'm-list-dots' : ''">{{
                    item.nama_file
                  }}</span>
                </template>                
              </a-list-item-meta>
            </a-list-item>
          </a-list> -->
          <a-list
            itemLayout="horizontal"
            :loading="uploading"
            :dataSource="push"
            v-if="push.length > 0"
          >
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <div
                  slot="title"
                  class="m-display-flex space-between align-middle"
                >
                  <h3>{{ item.document_description ? item.document_description : '-' }}</h3>
                  <a-button @click="handleRemove(item)" type="link"
                    >Delete</a-button
                  >
                </div>
                <template slot="description">
                  <span :class="getScreen ? 'm-list-dots' : ''">{{
                    item.nama_file
                  }}</span>
                </template>
                <!-- <img class="m-image-icon" slot="avatar" src="@/assets/icon/pdf_ico.png" /> -->
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-card>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "DokumenPendukung",
  props: {
    data: {},
    mode: String,
    listDokumen: {},
  },
  data() {
    return {
      file: "",
      uploading: false,
      push: [],
      existing: [],
      deleteExistingDoc: [],
      fungsi: "",
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    // this.existing =
    //   this.listDokumen.existing !== undefined ? this.listDokumen.existing : [];
    this.push =
      this.listDokumen.dokumenPendukung !== undefined
        ? this.listDokumen.dokumenPendukung
        : [];
    // this.deleteExistingDoc =
    //   this.listDokumen.deleteExistingDoc !== undefined
    //     ? this.listDokumen.deleteExistingDoc
    //     : [];
  },
  computed: {
    ...mapGetters(["getScreen", "getAuth"]),
  },
  mounted() {
    Event.$on("confirmMessageDelete", this.removeDoc);
  },
  beforeDestroy() {
    Event.$off("confirmMessageDelete", this.removeDoc);
  },
  methods: {
    removeDoc(params) {
      const index = this.push.indexOf(params);
      this.push.splice(index, 1);

      Event.$emit("updateDokumen", this.push);
      //this.confirmMessage("confirm-save");
    },
    handleRemoveExisting(id) {
      const index = this.existing.indexOf(id);
      //untuk list Delete
      const delPush = this.existing.filter(
        (item) => item.id_salesnotif_doc === id
      );
      this.deleteExistingDoc.push(delPush);
      //untuk list View
      const newPush = this.existing.filter(
        (item) => item.id_salesnotif_doc !== id
      );
      this.existing = newPush;
    },
    handleRemove(params) {
      // const index = this.push.indexOf(item.file.uid);
      // const newPush = this.push.filter((item) => item.file.uid !== file);
      // this.push = newPush;
      this.confirmMessageValue("confirm-delete", params);
    },
    beforeUpload(file) {
      // Event.$emit("newDocument", { file: file, fungsi: this.fungsi });
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        const FileSize = file.size / 1024 / 1024;
        if (FileSize > 10 ){
          this.displayMessage("large-file-10mb");
        } else {
          this.push = [
            ...this.push,
            {
              file,
              document_description: this.fungsi,
              nama_file: file.name,
            },
          ];

          this.fungsi = "";
          this.form.resetFields();

          Event.$emit("updateDokumen", this.push);
          return false;
        }
      });
    },
    async getApproval() {
      return await axios({
        method: "get",
        url: this.$serviceUrl + "rnd_notification/approval_rndnotif",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      });
    },
    handleRef() {
      // Event.$emit("updateDokumen", {
      //   dokumenPendukung: this.push,
      //   deleteExistingDoc: this.deleteExistingDoc
      // });

      if (this.mode == "Edit") {
        Event.$emit("SalesNotifData", {
          dokumenPendukung: this.push,
          deleteExistingDoc: this.deleteExistingDoc,
        });
      } else {
        this.getApproval()
          .then((res) => {
            Event.$emit("SalesNotifData", {
              dokumenPendukung: this.push,
              deleteExistingDoc: this.deleteExistingDoc,
              approval: res.data.approval,
            });
          })
          .catch((err) => {
            if (err.response) {
              this.$notification.error({
                message: "Error Message",
                description: err.response.data.message,
              });
            }
            return err;
          });
      }
    },
    handleRefBack() {
      Event.$emit("updateDokumenRefBack", {
        dokumenPendukung: this.push,
        deleteExistingDoc: this.deleteExistingDoc,
        existing: this.existing,
      });
    },
  },
};
</script>

<style>
</style>